.identityProviderDrawer {
    --exo-component-side-drawer-z-index: 1;
}
